import { useState } from 'react';
import { Button } from './ui/button';

export default function Newsletter({
  thankYouText,
  signUpText,
  ctaText,
  placeholderText,
}: {
  thankYouText: string;
  signUpText: string;
  ctaText: string;
  placeholderText: string;
}) {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<
    'idle' | 'pending' | 'success' | 'error'
  >('idle');

  // Basic client-side email pattern and free domains validation; we may want something stronger*.
  const isValidEmail = (value: string) => {
    const [username, domain] = value.split('@');
    return (
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) && domain && username.length >= 1
    );
  };
  const handleSubmit = async () => {
    const { PUBLIC_NEWSLETTER_URL } = import.meta.env;
    if (!isValidEmail(email)) {
      return;
    }
    setStatus('pending');

    try {
      setStatus('success');
      const response = await fetch(
        PUBLIC_NEWSLETTER_URL
          || 'https://wwn7thac36gsrxwe2b6vyba2gm0mtsbx.lambda-url.us-east-1.on.aws/',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ email, handler_key: 'newsletter-subscribe' }),
        },
      );
      setEmail('');
      if (!response.ok) {
        throw new Error(response.statusText || 'Failed to subscribe');
      }
    } catch (err) {
      console.error('Newsletter API error:', err);
      setStatus('error');
    }
  };

  return (
    <div
      className="flex flex-row flex-wrap items-center justify-between"
      data-id="footer-sign-up"
    >
      <h4
        className={`${status === 'success' || status === 'error' ? 'block' : 'hidden'} text-brand-purple-black animate-slide-in-bottom text-center group-data-[submitted=true]:block`}
      >
        {thankYouText}
      </h4>
      {status !== 'success' && status !== 'error' && (
        <>
          <div>
            <h4 className="group-data-[submitted=true]:hidde text-brand-purple-black-80 block">
              {signUpText}
            </h4>
          </div>
          <div className="bg-brand-purple-light relative my-4 flex justify-between rounded-[6.25rem] border-0">
            <input
              className="px-4 py-4 focus-visible:outline-none"
              type="email"
              placeholder={placeholderText}
              disabled={status === 'pending'}
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
            <Button
              disabled={status === 'pending' && isValidEmail(email) === true}
              onClick={handleSubmit}
              variant="tertiary"
              className="whitespace-break-spaces"
            >
              {ctaText}
            </Button>
          </div>
        </>
      )}
    </div>
  );
}
